(function () {
  'use strict';

  var STORAGE_KEY = 'apw_line_widget_closed';
  var AUTO_COLLAPSE_MS = 6000;
  var HOVER_COLLAPSE_DELAY_MS = 3000;

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function todayStr() {
    var d = new Date();
    return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
  }

  function isClosedToday() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === todayStr();
    } catch (e) {
      return false;
    }
  }

  function setClosedToday() {
    try {
      window.localStorage.setItem(STORAGE_KEY, todayStr());
    } catch (e) {}
  }

  function init() {
    var widget = document.getElementById('line-float-widget');
    if (!widget) return;

    if (isClosedToday()) {
      widget.classList.add('is-hidden');
      return;
    }

    var link = widget.querySelector('.line-float-widget__link');
    var closeBtn = widget.querySelector('.line-float-widget__close');
    var isMobile = window.matchMedia('(hover: none), (pointer: coarse)').matches;
    var autoTimer = null;
    var hoverTimer = null;
    var userInteracted = false;

    function expand() {
      widget.classList.add('is-expanded');
      link.setAttribute('aria-expanded', 'true');
    }

    function collapse() {
      widget.classList.remove('is-expanded');
      link.setAttribute('aria-expanded', 'false');
    }

    function clearTimers() {
      if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; }
      if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
    }

    expand();
    autoTimer = setTimeout(function () {
      if (!userInteracted) collapse();
    }, AUTO_COLLAPSE_MS);

    if (!isMobile) {
      widget.addEventListener('mouseenter', function () {
        userInteracted = true;
        clearTimers();
        expand();
      });
      widget.addEventListener('mouseleave', function () {
        clearTimers();
        hoverTimer = setTimeout(collapse, HOVER_COLLAPSE_DELAY_MS);
      });
    } else {
      link.addEventListener('click', function (e) {
        userInteracted = true;
        if (!widget.classList.contains('is-expanded')) {
          e.preventDefault();
          clearTimers();
          expand();
        }
      });
      document.addEventListener('click', function (e) {
        if (!widget.contains(e.target) && widget.classList.contains('is-expanded')) {
          collapse();
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearTimers();
        widget.classList.add('is-hidden');
        setClosedToday();
      });
    }

    link.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        link.click();
      }
    });
    widget.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        clearTimers();
        collapse();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();